let UniquePlayersQuantity = {
    SET_UNIQUE_PLAYERS_QUANTITY: 'SET_UNIQUE_PLAYERS_QUANTITY',
    DEFAULT_UNIQUE_PLAYERS_QUANTITY: 1,
};

export default UniquePlayersQuantity;
